/** biome-ignore-all assist/source/useSortedAttributes: <more readable> */

import { lazyImport } from "@resamare/ui";
import { Navigate, Route, Routes } from "react-router-dom";
import DefaultLayout from "@/components/Layout/DefaultLayout";

const { ScanPage } = lazyImport(() => import("../pages"), "ScanPage");

export function ScanRoutes() {
    return (
        <Routes>
            <Route element={<DefaultLayout />}>
                <Route path="/" element={<ScanPage />} />
                <Route path="*" element={<Navigate to="." />} />
            </Route>
        </Routes>
    );
}
